import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import useAuth from '../../hooks/useAuth';

const AuthGuard = ({ children }) => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const cmpId = JSON.parse(localStorage.getItem('cmpId'));

  const customAlert = (v, w) => {
    Swal.fire({
      text: v,
      icon: w
    });
  };

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/auth/signin-2', { replace: true });
    }
    else {
      if (isLoggedIn && !cmpId) {
        navigate('/auth/tabs-auth', { replace: true });
      }
      if (isLoggedIn && user?.firstLoginYn === 'Y') {
        customAlert("Redirecting to change password", "warning");
        setTimeout(() => {
          navigate('/auth/reset-password-1', { replace: true });
        }, 2000);
      }
    }
  }, [isLoggedIn, navigate, cmpId]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthGuard;
